export const SubscriptionStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const StatusCode = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
};

export const LOCAL_FAVORITES_KEY = 'localFavorites';

export const ListingState = Object.freeze({
  PUBLISHED: 'published',
  CLOSED: 'closed',
  DRAFT: 'draft',
  ALL: 'all',
});

export const subscriptionFAQ = [
  {
    label: 'Is there a free trial?',
    body:
      'No, Choose & Cheers does not offer a free trial. We provide detailed and up-to-date pricing information from venues, which would take planners countless hours to gather through emails, calls, and follow-ups.',
  },
  {
    label: 'Can I change my plan later?',
    body:
      'Your subscription will include the Warm-Up Plan for one year. You can unlock the Pro Plan and receive a discount if you book 4 or more venues through Choose & Cheers within that year.',
  },
  {
    label: 'What is the cancellation policy?',
    body:
      'You can cancel your subscription at any time before it renews (1 year from the payment date). If you cancel during your active subscription, you will retain access to the platform until the end of the paid period.',
  },
];

export const UserRole = {
  BUYER: 'buyer',
  SELLER: 'seller',
};